import { render, staticRenderFns } from "./followupHistoryList.vue?vue&type=template&id=6a762089&scoped=true&"
import script from "./followupHistoryList.vue?vue&type=script&lang=js&"
export * from "./followupHistoryList.vue?vue&type=script&lang=js&"
import style0 from "./followupHistoryList.vue?vue&type=style&index=0&id=6a762089&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a762089",
  null
  
)

export default component.exports